import { useTranslation } from "react-i18next";
import { AppIdentity, AppSecretField, ModuleIdField } from "./component";

function Credentials() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-10 p-8 m-5 border border-line rounded-lg">
      <h1 className="m-0 text-base font-medium text-primary">
        {t("credentials.title")}
      </h1>

      <section className="flex w-full flex-col gap-8">
        <AppIdentity />
        <div className="h-px w-full bg-line" />
        <ModuleIdField />
        <div className="h-px w-full bg-line" />
        <AppSecretField />
      </section>
    </div>
  );
}

export default Credentials;
